import React from "react";
import AcquireWebComponent from "../framework/MaterialUI";
import { Link } from "react-router-dom";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";

class InsightBreadcrumb extends AcquireWebComponent {
  render() {
    const url = new URL(window.location.href);
    const page = url.searchParams.get("pop_url");

    const { src, kindOfReport, clientId, popUrl } = this.props;
    let popUrlElement = null;
    if (popUrl) {
      popUrlElement = popUrl;
    }
    let reportLinkContainer = undefined;
    let reportKindContainer = undefined;
    switch (kindOfReport) {
      case "map":
        reportKindContainer = (
          <span key="span-report-kind"> Geographic Traffic </span>
        );
        break;
      case "top":
        reportKindContainer = (
          <span key="span-report-kind">
            {" "}
            {src === "consumer" ? "Top Attributes" : "Frequency Visits"}{" "}
          </span>
        );
        break;
      case "popular":
        reportKindContainer = (
          <span key="span-report-kind"> Most Popular Pages</span>
        );
        break;
      case "frequents":
        reportKindContainer = (
          <span key="span-report-kind"> Frequent Visits</span>
        );
        break;
      default:
        reportKindContainer = page ? [] : undefined;
        break;
    }

    switch (src) {
      case "consumer":
        if (this.props.nav === "pop") {
          if (popUrl) {
            reportLinkContainer = (
              <span key="span-report-type">
                <Link to={"/insights/consumer?cid=" + clientId + "&nav=pop"}>
                  {" "}
                  Most Popular Pages{" "}
                </Link>
              </span>
            );
          } else {
            reportLinkContainer = (
              <span key="span-report-type"> Consumer Information </span>
            );
          }
        } else {
          reportLinkContainer =
            isUndefined(kindOfReport) && isNull(page) ? (
              <span key="span-report-type"> Consumer Information </span>
            ) : (
              <span key="span-report-type">
                <Link to={"/insights/consumer?cid=" + clientId}>
                  Consumer Information
                </Link>
              </span>
            );
        }
        /*
        if (page) {
          reportKindContainer.push(
            <span>
              <Link to={"/insights/consumer?nav=pop&cid=" + clientId}>
                Most Popular Pages
              </Link>
            </span>,
          );
          reportKindContainer.push(
            <span
              key="span-insights-breadcrumb-divider3"
              className="ml-10 mr-10"
            >
              >
            </span>,
          );
          reportKindContainer.push(<span> {page} </span>);
        }*/
        return (
          <div className="page-breadcrumb">
            <Link to={"/insights/summary?cid=" + clientId}>
              Insights Dashboard
            </Link>
            <span
              key="span-insights-breadcrumb-divider1"
              className="ml-10 mr-10"
            >
              >
            </span>
            {reportLinkContainer}
            {reportKindContainer
              ? [
                  <span
                    key="span-insights-breadcrumb-divider2"
                    className="ml-10 mr-10"
                  >
                    >
                  </span>,
                  reportKindContainer,
                ]
              : []}
            {popUrlElement}
          </div>
        );
      default:
        reportLinkContainer =
          isUndefined(kindOfReport) && isNull(page) ? (
            <span key="span-report-type"> Business Information </span>
          ) : (
            <span key="span-report-type">
              <Link to={"/insights/business?cid=" + clientId}>
                Business Information
              </Link>
            </span>
          );

        return (
          <div className="page-breadcrumb">
            <Link to="/insights/summary">Insights Dashboard</Link>
            <span
              key="span-insights-breadcrumb-divider1"
              className="ml-10 mr-10"
            >
              >
            </span>
            {reportLinkContainer}
            {reportKindContainer
              ? [
                  <span
                    key="span-insights-breadcrumb-divider2"
                    className="ml-10 mr-10"
                  >
                    >
                  </span>,
                  reportKindContainer,
                ]
              : []}
            {popUrlElement}
          </div>
        );
    }
  }
}

export default InsightBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/Insights/InsightBreadcrumb.jsx